__turbopack_context__.v({
  "mobile-nav-wrap": "vkGYAG_mobile-nav-wrap",
});
